import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArchiveLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.7041 2.76074C20.7128 2.863 21.5 3.71435 21.5 4.75V6.75C21.5 7.2648 21.3049 7.73354 20.9854 8.08789C20.994 8.14074 21 8.19472 21 8.25V17.25C21 19.39 19.3194 21.1379 17.2061 21.2451L17 21.25H7L6.79395 21.2451C4.7488 21.1413 3.10865 19.5012 3.00488 17.4561L3 17.25V8.25C3 8.19477 3.00506 8.14068 3.01367 8.08789C2.73738 7.78097 2.55474 7.38803 2.51074 6.9541L2.5 6.75V4.75C2.5 3.64543 3.39543 2.75 4.5 2.75H19.5L19.7041 2.76074ZM4.5 17.25C4.5 18.6307 5.61929 19.75 7 19.75H17C18.3807 19.75 19.5 18.6307 19.5 17.25V8.75H4.5V17.25ZM15 11.5C15.4142 11.5 15.75 11.8358 15.75 12.25C15.75 12.6642 15.4142 13 15 13H9C8.58579 13 8.25 12.6642 8.25 12.25C8.25 11.8358 8.58579 11.5 9 11.5H15ZM4.5 4.25C4.22386 4.25 4 4.47386 4 4.75V6.75C4 7.02614 4.22386 7.25 4.5 7.25H19.5C19.7761 7.25 20 7.02614 20 6.75V4.75C20 4.47386 19.7761 4.25 19.5 4.25H4.5Z",
		fill: "currentColor"
	})
});
export default SvgArchiveLine;
